const GlobalStockTable = require('./GlobalStockTable');

module.exports = GlobalStockTable;
